// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_992d80b"};